var map = {
	"./27-bg-3.png": 2887,
	"./28-bg-3.png": 8923,
	"./30-bg-3.png": 1401,
	"./31-bg-3.png": 5448,
	"./33-bg-3.png": 3106,
	"./36-bg-3.png": 7908,
	"./42-bg-3.png": 8808,
	"./45-bg-3.png": 1981,
	"./51-bg-3.png": 7031,
	"./52-bg-3.png": 5408,
	"./54-bg-3.png": 3378,
	"./55-bg-3.png": 4134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2723;